// extracted by mini-css-extract-plugin
var _1 = "ASP6qG5WMo";
var _2 = "k0c0fjP9sL";
var _3 = "FY_QvlYHaA";
var _4 = "iadUoJn_WA";
var _5 = "PKjyQlqf35";
export { _1 as "name", _2 as "nameValue", _3 as "value", _4 as "value_less", _5 as "value_more" }
